export const STANDARD_PRICE_ASC = 'standard.asc';
export const PRICE_ASC = 'offerPrice.amountMinorUnits.asc';
export const PRICE_DESC = 'offerPrice.amountMinorUnits.desc';
export const DISTANCE_ASC = 'mileage.distance.asc';
export const DISTANCE_DESC = 'mileage.distance.desc';
export const MANUFACTURER_ASC = 'manufacturer.asc';
export const MANUFACTURER_DESC = 'manufacturer.desc';
export const MODIFIED_AT_DESC = 'modifiedAt.desc';
export const PUBLISHED_AT_DESC = 'firstPublishedAt.desc';
export const GEOLOCATION_DISTANCE_ASC = 'distance.asc';
export const MONTHLY_PRICE_ASC = 'monthlyPayment.amountMinorUnits.asc';
export const MONTHLY_PRICE_DESC = 'monthlyPayment.amountMinorUnits.desc';
